<template>
    <div>
        <sidenav :orientation="orientation" class="sidenav sidenav-vertical bg-sidenav-theme layout-sidenav">
            <!-- Inner -->
            <div class="media pl-3 usercard" v-if="user">
                <div class="media-body ml-3">
                    <span class="userid">{{ user.userprofile.lastname }} {{ user.userprofile.firstname }}</span>
                    <div class="text-muted small usertype">{{ user.userprofile.user_type.label }}</div>
                </div>
            </div>
            <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }">
                <sidenav-router-link icon="ion ion-ios-home" to="/" :exact="true">{{ $t('welcome')}}
                </sidenav-router-link>
                <sidenav-menu
                        icon="ion ion-md-settings" :active="isMenuActive('/survey/')"
                        :open="isMenuOpen('/survey/')">
                    <template slot="link-text">Capteurs / Enquêtes</template>
                    <sidenav-router-link to="/survey/">Enquêtes
                    </sidenav-router-link>
                    <sidenav-router-link to="/get-report/">Résultats
                    </sidenav-router-link>
                </sidenav-menu>
                <sidenav-router-link icon="ion ion-md-document" to="/elearning/" :exact="true">E-learning
                </sidenav-router-link>
                <sidenav-router-link icon="ion ion-md-code-download" to="/documentation/" :exact="true">Toolkit
                </sidenav-router-link>
                <sidenav-menu
                              icon="ion ion-md-settings" :active="isMenuActive('/dashboard/administration/')"
                              :open="isMenuOpen('/forum/')">
                    <template slot="link-text">Echanges</template>
                    <sidenav-router-link to="/echanges/news/">Actualités
                    </sidenav-router-link>
                    <sidenav-router-link to="/echanges/forum/">Forum
                    </sidenav-router-link>
                </sidenav-menu>
                <sidenav-router-link v-if="user.userprofile.coaching || user.userprofile.codev || user.userprofile.support"
                                     icon="ion ion-md-code-download" to="/coaching/" :exact="true">Coaching
                </sidenav-router-link>
                <sidenav-menu v-if="user !== null && (user.userprofile.user_type.slug === 'obea_admin')"
                              icon="ion ion-md-settings" :active="isMenuActive('/dashboard/administration/')"
                              :open="isMenuOpen('/dashboard/administration/')">
                    <template slot="link-text">Administration</template>
                    <sidenav-router-link to="/dashboard/administration/userlist/">Gestion des Utilisateurs
                    </sidenav-router-link>
                    <sidenav-router-link to="/dashboard/administration/documentation/">Document pédagogiques
                    </sidenav-router-link>
                    <sidenav-router-link to="/dashboard/administration/questionnary/">Gestion des questions
                    </sidenav-router-link>
                    <sidenav-router-link to="/dashboard/administration/forum/">Gestion des catégories forum
                    </sidenav-router-link>
                </sidenav-menu>
                <sidenav-menu v-if="user !== null && (user.userprofile.user_type.slug === 'obea_consultant')"
                              icon="ion ion-md-settings" :active="isMenuActive('/dashboard/administration/')"
                              :open="isMenuOpen('/dashboard/administration/')">
                    <template slot="link-text">Administration</template>
                    <sidenav-router-link to="/dashboard/administration/documentation/">Document pédagogiques
                    </sidenav-router-link>
                    <sidenav-router-link to="/dashboard/administration/questionnary/">Gestion des questions
                    </sidenav-router-link>
                    <sidenav-router-link to="/dashboard/administration/forum/">Gestion des catégories forum
                    </sidenav-router-link>
                </sidenav-menu>
            </div>
            <div class="footermenu text-center text-muted">
                <img class="mb-1" :src="require('@/assets/logo_opengraph.png')" style="height:20px;"/><br/>
                <a href="/confidentiality/">{{ $t('privacy')}}</a><br/>
                <a href="/legals/">{{ $t('legales')}}</a>&nbsp;-&nbsp;<a href="/cookies/">{{ $t('cookies_managment')}}</a>
            </div>
        </sidenav>
    </div>
</template>
<style>
    .footermenu {
        padding: 20px;
        font-size: 11px;
    }
    
    .sidenav {
        padding-top: 64px;
    }
    
    .bg-sidenav-theme {
        background-color: #ffffff !important;
    }
    
    .bg-sidenav-theme .sidenav-link, .bg-sidenav-theme .sidenav-horizontal-prev, .bg-sidenav-theme .sidenav-horizontal-next {
        color: #42a8bf;
    }
    
    .bg-sidenav-theme .sidenav-item.open:not(.sidenav-item-closing) > .sidenav-toggle, .bg-sidenav-theme .sidenav-item.active > .sidenav-link {
        color: #42a8bf !important;
        font-weight: bold;
    }
    
    .bg-sidenav-theme .sidenav-link:hover, .bg-sidenav-theme .sidenav-link:focus, .bg-sidenav-theme .sidenav-horizontal-prev:hover, .bg-sidenav-theme .sidenav-horizontal-prev:focus, .bg-sidenav-theme .sidenav-horizontal-next:hover, .bg-sidenav-theme .sidenav-horizontal-next:focus {
        color: #ffffff !important;
        background-color: #05a9c4;
    }
    
    .bg-sidenav-theme .sidenav-item.active > .sidenav-link:not(.sidenav-toggle) {
        background-color: #E5F5F7;
        color: #00AAC2 !important
    }
    
    .userid {
        font-size: 1.3rem;
        font-weight: 700;
        color: rgba(4, 169, 196, 1) !important;
    }
    
    .usertype {
        color: rgba(4, 169, 196, 1) !important;
    }
    
    .usercard {
        padding-top: 30px;
        padding-bottom: 30px;
        border-bottom: 3px solid #f5f5f5;
        border-top: 3px solid #f5f5f5;
        color: rgba(4, 169, 196, 1);
    }
</style>
<script>
    import {
        Sidenav,
        SidenavLink,
        SidenavRouterLink,
        SidenavMenu,
        SidenavHeader,
        SidenavBlock,
        SidenavDivider
    } from '@/vendor/libs/sidenav'
    import {mapState} from 'vuex';

    export default {
        name: 'app-layout-sidenav',
        components: {
            /* eslint-disable vue/no-unused-components */
            Sidenav,
            SidenavLink,
            SidenavRouterLink,
            SidenavMenu,
            SidenavHeader,
            SidenavBlock,
            SidenavDivider
            /* eslint-enable vue/no-unused-components */
        },

        props: {
            orientation: {
                type: String,
                default: 'vertical'
            }
        },

        computed: mapState({user: state => state.user.user}),

        methods: {
            isMenuActive(url) {
                return this.$route.path.indexOf(url) === 0
            },

            isMenuOpen(url) {
                return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
            },

            toggleSidenav() {
                this.layoutHelpers.toggleCollapsed()
            }
        }
    }
</script>
